import { render, staticRenderFns } from "./BadgeSettings.vue?vue&type=template&id=e461e142&scoped=true"
import script from "./BadgeSettings.vue?vue&type=script&lang=js"
export * from "./BadgeSettings.vue?vue&type=script&lang=js"
import style0 from "./BadgeSettings.vue?vue&type=style&index=0&id=e461e142&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e461e142",
  null
  
)

export default component.exports